module.exports = __webpack_public_path__ + "static/media/LogoSponsor-17.27d38c81.png";